export const ETRN_STEP_GUIDES = {
  title1_filled: {
    stage: "Титул 1",
    title: "Заполняет грузоотправитель",
    actor: "Грузоотправитель",
    actorTitle: "Кто заполняет",
    summary: "Грузоотправитель заявляет, какой груз передаёт к перевозке и на каких условиях.",
    payload: "Маршрут, участники, груз, транспорт, водитель, условия перевозки и сведения о погрузке со стороны отправителя.",
    next: "После заполнения грузоотправитель подписывает титул 1, чтобы передать документ перевозчику.",
    note: "Замечания по фактической приемке груза перевозчик фиксирует не здесь, а в титуле 2.",
    tone: "shipper",
  },
  title1_signed: {
    stage: "Титул 1",
    title: "Подписывает грузоотправитель",
    actor: "Грузоотправитель или уполномоченное им лицо",
    actorTitle: "Кто подписывает",
    summary: "Подпись подтверждает сведения отправителя и переводит ЭТрН на сторону перевозчика.",
    payload: "Электронная подпись отправителя под исходными данными перевозки и предъявлением груза.",
    next: "После подписи перевозчик получает возможность оформить титул 2 по фактической приемке груза.",
    note: "Если фактически грузит отдельное лицо, сценарий подписанта титула 1 нужно проектировать отдельно.",
    tone: "shipper",
  },
  title2_available: {
    stage: "Титул 2",
    title: "Заполняет перевозчик при приемке",
    actor: "Перевозчик или представитель перевозчика на погрузке",
    actorTitle: "Кто заполняет",
    summary: "Перевозчик принимает груз к перевозке и сверяет факт с данными титула 1.",
    payload: "Факт приемки груза, сведения перевозчика, обстоятельства погрузки и возможные замечания по грузу.",
    next: "После заполнения перевозчик подписывает титул 2, и документ переходит к этапу доставки и приемки грузополучателем.",
    note: "Если при погрузке груз поврежден, не совпадает количество мест, масса или упаковка, замечания фиксируются здесь.",
    tone: "carrier",
  },
  title2_signed: {
    stage: "Титул 2",
    title: "Подписывает перевозчик",
    actor: "Перевозчик",
    actorTitle: "Кто подписывает",
    summary: "Подпись подтверждает, что перевозчик принял груз к перевозке, с замечаниями или без них.",
    payload: "Электронная подпись перевозчика под результатом приемки груза на погрузке.",
    next: "После подписи титула 2 грузополучатель сможет оформить титул 3 при получении груза.",
    note: "Этот этап закрывает приемку на погрузке, но не приемку у получателя.",
    tone: "carrier",
  },
  title3_available: {
    stage: "Титул 3",
    title: "Заполняет грузополучатель",
    actor: "Грузополучатель или уполномоченное на приемку лицо",
    actorTitle: "Кто заполняет",
    summary: "Грузополучатель принимает груз от перевозчика и фиксирует результат доставки.",
    payload: "Факт приемки, состояние принятого груза, расхождения, частичная приемка или отказ от приемки.",
    next: "После заполнения грузополучатель подписывает титул 3, чтобы зафиксировать результат приемки.",
    note: "Если проблема обнаружилась уже на выгрузке, она фиксируется на этом этапе.",
    tone: "consignee",
  },
  title3_signed: {
    stage: "Титул 3",
    title: "Подписывает грузополучатель",
    actor: "Грузополучатель",
    actorTitle: "Кто подписывает",
    summary: "Подпись подтверждает приемку груза получателем или фиксирует приемку с расхождениями.",
    payload: "Электронная подпись грузополучателя под результатом получения груза.",
    next: "После подписи титула 3 перевозчик оформляет титул 4 о выдаче груза.",
    note: "Этот этап фиксирует позицию получателя, а выдачу со стороны перевозчика закрывает титул 4.",
    tone: "consignee",
  },
  title4_available: {
    stage: "Титул 4",
    title: "Заполняет перевозчик при выдаче",
    actor: "Перевозчик или представитель перевозчика на выгрузке",
    actorTitle: "Кто заполняет",
    summary: "Перевозчик фиксирует выдачу груза получателю и завершает перевозочную часть ЭТрН.",
    payload: "Факт выдачи груза, сведения о выгрузке, время прибытия и убытия, замечания по грузу или выгрузке.",
    next: "После заполнения перевозчик подписывает титул 4.",
    note: "Титул 4 нужен, чтобы закрыть действие перевозчика после приемки груза получателем.",
    tone: "carrier",
  },
  title4_signed: {
    stage: "Титул 4",
    title: "Подписывает перевозчик",
    actor: "Перевозчик",
    actorTitle: "Кто подписывает",
    summary: "Подпись подтверждает, что перевозчик выдал груз и зафиксировал итог выгрузки.",
    payload: "Электронная подпись перевозчика под сведениями о выдаче груза получателю.",
    next: "После подписи титула 4 основной flow ЭТрН считается завершенным.",
    note: "Если после этого нужны исправления, они оформляются отдельными сценариями изменения или переадресации.",
    tone: "carrier",
  },
  redirect_available: {
    stage: "Титул 7",
    title: "Переадресовка груза",
    actor: "Перевозчик",
    actorTitle: "Кто оформляет",
    summary: "Перевозчик фиксирует изменение места выгрузки или грузополучателя во время перевозки.",
    payload: "Причина переадресовки, новый пункт выгрузки, дата изменения и контактные данные.",
    next: "После заполнения перевозчик подписывает переадресовку отдельной электронной подписью.",
    note: "Переадресовка — независимый дополнительный титул и не является следующим шагом основной цепочки Т1–Т4.",
    tone: "carrier",
  },
  redirect_signed: {
    stage: "Титул 7",
    title: "Подпись переадресовки",
    actor: "Перевозчик",
    actorTitle: "Кто подписывает",
    summary: "Подпись перевозчика подтверждает сведения об изменении места доставки.",
    payload: "Электронная подпись под данными переадресовки.",
    next: "Основная цепочка ЭТрН продолжается независимо от этого титула.",
    note: "Статус основной цепочки Т1–Т4 не вычисляется по состоянию переадресовки.",
    tone: "carrier",
  },
  replacement_available: {
    stage: "Титул 8",
    title: "Замена водителя или ТС",
    actor: "Перевозчик",
    actorTitle: "Кто оформляет",
    summary: "Перевозчик фиксирует замену водителя или транспортного средства во время перевозки.",
    payload: "Причина и время замены, сведения о новом водителе и транспортном средстве.",
    next: "После заполнения перевозчик подписывает сведения о замене отдельной электронной подписью.",
    note: "Замена — независимый дополнительный титул и не является следующим шагом основной цепочки Т1–Т4.",
    tone: "carrier",
  },
  replacement_signed: {
    stage: "Титул 8",
    title: "Подпись замены",
    actor: "Перевозчик",
    actorTitle: "Кто подписывает",
    summary: "Подпись перевозчика подтверждает сведения о замене водителя или транспортного средства.",
    payload: "Электронная подпись под данными замены.",
    next: "Основная цепочка ЭТрН продолжается независимо от этого титула.",
    note: "Статус основной цепочки Т1–Т4 не вычисляется по состоянию замены.",
    tone: "carrier",
  },
};

export const ETRN_FALLBACK_GUIDE = {
  stage: "Этап ЭТрН",
  actor: "Участник ЭТрН по текущему шагу",
  summary: "Этап документооборота ЭТрН.",
  payload: "Сведения текущего титула ЭТрН.",
  next: "Следующий участник получает документ после завершения текущего титула или подписи.",
};
